export default "__VITE_ASSET__DKVuah_h__"